export default "__VITE_ASSET__C8Gm03A9__"